import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

/* ══════════════════════════════════════════════════════════════════════════
   Anciennes adresses → nouvel emplacement (Navigate replace). Les liens et
   favoris existants continuent de fonctionner, paramètres compris.
   ══════════════════════════════════════════════════════════════════════════ */

/** Ancienne adresse fixe → nouvelle, en gardant ?paramètres et #ancre. */
export const ANCIENNES_ADRESSES: Record<string, string> = {
  "/dashboard": "/accueil",
  "/home": "/accueil",
  "/location_types": "/reglages/types-de-lieu",
  "/types_lieu": "/reglages/types-de-lieu",
  "/produits": "/reglages/produits",
  "/pricing": "/reglages/moteur-de-prix",
  "/bonus": "/reseau/concours",
  "/achievements": "/reseau/reputation",
  "/gifts": "/reseau/reputation/tips-offerts",
  "/user_location": "/reseau/spotters",
  "/user_token": "/argent/soldes",
  "/user_access": "/reseau/restrictions",
  "/profile": "/reglages/profil",
  "/create_user": "/reglages/equipe",
  "/user_admin": "/reglages/equipe",
  "/admin/team": "/reglages/equipe",
  "/admin/superadmin": "/reglages/equipe",
  "/extract_data": "/analyses/exports",
  "/quests": "/quetes/liste",
  "/create_quest": "/quetes/creer",
  "/finance": "/argent/ventes",
  "/communications": "/reseau/communications",
  "/dataviz": "/analyses/comparaison-des-sources",
  "/trous_donnees": "/analyses/trous",
};

/** Adresses traitées à part : /location (selon ?onglet), /configuration (selon
    l'ancre), /freshness, /add_more, /quest/:id. */
export const ADRESSES_PARTICULIERES = ["/location", "/configuration", "/freshness", "/add_more"];

/** Vrai pour une ancienne adresse : elle ne fait que rediriger. */
export function estAncienneAdresse(pathname: string): boolean {
  return pathname in ANCIENNES_ADRESSES
    || ADRESSES_PARTICULIERES.includes(pathname)
    || /^\/quest\/[^/]+$/.test(pathname);
}

export function Redirection({ vers }: { vers: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${vers}${search}${hash}`} replace />;
}

const ONGLETS_FILE = ["attente", "verifie", "approuve", "rejete", "expire", "masque"];

/* /location ouvrait la carte ; /location?onglet=X ouvrait la validation sur
   l'onglet X (liens du tableau de bord). */
export function RedirectionLieux() {
  const { search } = useLocation();
  const onglet = new URLSearchParams(search).get("onglet") ?? "";
  return ONGLETS_FILE.includes(onglet)
    ? <Navigate to={`/a-traiter/lieux?onglet=${onglet}`} replace />
    : <Navigate to="/analyses/carte" replace />;
}

/* /configuration regroupait tout ; ses sections sont réparties entre Argent
   (valeur du Tip, facturation) et Réglages (le reste). */
export function RedirectionConfiguration() {
  const { hash } = useLocation();
  if (hash === "#tips") return <Navigate to="/argent/valeur-du-tip" replace />;
  if (hash === "#facturation") return <Navigate to="/argent/facturation" replace />;
  return <Navigate to={`/reglages/parametres${hash}`} replace />;
}

export function RedirectionQuete() {
  const { id } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`/quetes/${id ?? ""}${search}${hash}`} replace />;
}
